/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectLegacyReport = {
    DailyOverview: 'DailyOverview',
    MainOverview: 'MainOverview',
    MarketingAndSales: 'MarketingAndSales',
    DiscountsAndCoupons: 'DiscountsAndCoupons',
    CampaignPerformance: 'CampaignPerformance',
    CampaignComparison: 'CampaignComparison'
} as const;
export type ProjectLegacyReport = typeof ProjectLegacyReport[keyof typeof ProjectLegacyReport];


export function instanceOfProjectLegacyReport(value: any): boolean {
    for (const key in ProjectLegacyReport) {
        if (Object.prototype.hasOwnProperty.call(ProjectLegacyReport, key)) {
            if (ProjectLegacyReport[key as keyof typeof ProjectLegacyReport] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectLegacyReportFromJSON(json: any): ProjectLegacyReport {
    return ProjectLegacyReportFromJSONTyped(json, false);
}

export function ProjectLegacyReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectLegacyReport {
    return json as ProjectLegacyReport;
}

export function ProjectLegacyReportToJSON(value?: ProjectLegacyReport | null): any {
    return value as any;
}

export function ProjectLegacyReportToJSONTyped(value: any, ignoreDiscriminator: boolean): ProjectLegacyReport {
    return value as ProjectLegacyReport;
}

